module.exports = __webpack_public_path__ + "static/media/vegitables_31.07b16164.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_31.csv
// module id = 615
// module chunks = 0